import { render, staticRenderFns } from "./UserTabFiles.vue?vue&type=template&id=81e8f4c4"
import script from "./UserTabFiles.vue?vue&type=script&lang=js"
export * from "./UserTabFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports